/**
 * Once Cero — Press Start gate.
 *
 * The gate is an overlay, not a route: all page content is already in the DOM
 * behind it, so crawlers and deep links are unaffected. Dismissal can be
 * remembered per visitor so repeat traffic skips the interstitial.
 */
(function () {
  'use strict';

  var KEY = 'oc:gate:dismissed';

  function readDismissed() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return false;
      var until = parseInt(raw, 10);
      if (isNaN(until)) return false;
      if (Date.now() > until) {
        window.localStorage.removeItem(KEY);
        return false;
      }
      return true;
    } catch (e) {
      // Private mode, blocked storage, or a browser that throws on access.
      return false;
    }
  }

  function remember(days) {
    try {
      window.localStorage.setItem(KEY, String(Date.now() + days * 86400000));
    } catch (e) {
      /* nothing to do — the gate simply shows again next visit */
    }
  }

  function init() {
    var gate = document.querySelector('[data-oc-gate]');
    if (!gate) return;

    var scope = gate.getAttribute('data-scope') || 'remember';
    var days = parseInt(gate.getAttribute('data-remember-days'), 10) || 30;
    var cta = gate.querySelector('[data-oc-gate-start]');
    var opener = document.activeElement;

    if (scope === 'remember' && readDismissed()) {
      gate.remove();
      return;
    }

    gate.hidden = false;
    document.documentElement.classList.add('oc-gate-open');
    if (cta) cta.focus();

    function dismiss() {
      if (scope === 'remember') remember(days);
      document.documentElement.classList.remove('oc-gate-open');
      gate.hidden = true;
      gate.removeEventListener('keydown', onKey);

      // Move focus for keyboard and screen-reader users, but never scroll:
      // a plain focus() scrolls the target into view, which jumped the page
      // down and clipped the header straight off the top.
      var main = document.getElementById('MainContent');
      if (main) {
        main.focus({ preventScroll: true });
      } else if (opener && opener.focus) {
        opener.focus({ preventScroll: true });
      }

      // The gate is a full-screen interstitial: land at the top of the page.
      window.scrollTo(0, 0);

      gate.remove();
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        dismiss();
      } else if (e.key === 'Tab') {
        // Only one control exists; keep focus on it while the gate is up.
        e.preventDefault();
        if (cta) cta.focus();
      }
    }

    if (cta) cta.addEventListener('click', dismiss);
    gate.addEventListener('keydown', onKey);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
